import { AxiosInstance } from 'axios';
import { SiteAnnouncement, SiteAnnouncementCreateDTO, SiteAnnouncementListDTO, SiteAnnouncementUpdateDTO } from 'core/siteAnnouncement/SiteAnnouncement';
import client from './RestClient';

export interface SiteAnnouncementWebService {
  getSiteAnnouncement: (id: number) => Promise<SiteAnnouncement>;
  getSiteAnnouncements: () => Promise<SiteAnnouncementListDTO[]>;
  createSiteAnnouncement: (createDTO: SiteAnnouncementCreateDTO) => Promise<void>;
  updateSiteAnnouncement: (updateDTO: SiteAnnouncementUpdateDTO) => Promise<void>;
  // 每個通知分類各回最新一則（依 publishTime DESC），無資料時回空陣列
  getTopAnnouncement: (vendorNumber: string) => Promise<SiteAnnouncement[]>;
  activateAnnouncements: (ids: number[]) => Promise<void>;
  deactivateAnnouncements: (ids: number[]) => Promise<void>;
  deleteAnnouncements: (ids: number[]) => Promise<void>;
}

export class RestfulSiteAnnouncementWebService implements SiteAnnouncementWebService {
  private restClient: AxiosInstance;

  constructor (restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getSiteAnnouncement (id: number): Promise<SiteAnnouncement> {
    const response = await this.restClient.get(`/v2/site-announcements/${id}`);
    return response.data;
  }

  async getSiteAnnouncements (): Promise<SiteAnnouncementListDTO[]> {
    const response = await this.restClient.get('/v2/site-announcements');
    return response.data.records;
  }

  async createSiteAnnouncement (createDTO: SiteAnnouncementCreateDTO): Promise<void> {
    await this.restClient.post('/v2/site-announcements', createDTO);
  }

  async updateSiteAnnouncement (updateDTO: SiteAnnouncementUpdateDTO): Promise<void> {
    await this.restClient.put('/v2/site-announcements', updateDTO);
  }

  async getTopAnnouncement (vendorNumber: string): Promise<SiteAnnouncement[]> {
    const response = await this.restClient.get(`/v2/site-announcements/top?vendorNumber=${vendorNumber}`);
    return response.data;
  }

  async activateAnnouncements (ids: number[]): Promise<void> {
    await this.restClient.put(`/v2/site-announcements/activate?ids=${ids.join(',')}`);
  }

  async deactivateAnnouncements (ids: number[]): Promise<void> {
    await this.restClient.put(`/v2/site-announcements/deactivate?ids=${ids.join(',')}`);
  }

  async deleteAnnouncements (ids: number[]): Promise<void> {
    await this.restClient.delete(`/v2/site-announcements?ids=${ids.join(',')}`);
  }
}
